import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message, Segment } from 'semantic-ui-react';

export const QueryNoResultsFallback = () => {
  const { t } = useTranslation();
  return (
    <Segment>
      <Message>{t('common.noResults', 'No Results')}</Message>
    </Segment>
  );
};
